import script from "./DataStorePlus.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataStorePlus.vue?vue&type=script&setup=true&lang=ts"

import "./DataStorePlus.vue?vue&type=style&index=0&id=7f7dab66&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7dab66"]])

export default __exports__